export class Banks {
  BankCode;
  CName;
  EName;
  constructor() {
    this.BankCode = "";
    this.CName = "";
    this.EName = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Banks.js